import { makeStyles } from '@material-ui/styles';
import { DefaultTheme } from '@material-ui/styles';

const useStyles = makeStyles<DefaultTheme>({
    view_horizon_mottled: {
        width: '100%',
        backgroundColor: 'transparent',
    },
    view_horizon_mottled_title: {
        backgroundColor: 'transparent',
        marginBottom: 10,
    },
    text_horizon_mottled: {
        fontFamily: 'serca-condensed-text',
        letterSpacing: 1,
        fontSize: 16,
        color: "#000000",
        fontWeight: "bold",
        textAlign: "center"
    },
    view_horizon_mottled_subtitle: {
        flexDirection: 'column',
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    text_horizon_mottled_subtitle: {
        flexDirection: 'row',
        backgroundColor: 'transparent',
        alignItems: 'center',
    },
    view_horizon_mottled_content: {
        width: '100%',
        backgroundColor: 'transparent',
        marginBottom: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    picker_select_type: {
        padding: '10px 20px !important',
        width: '300px',
        borderRadius: 15,
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '10px !important',
        '& fieldset.MuiOutlinedInput-notchedOutline': {
            borderColor: '#06617c !important',
        }
    },
    picker_select_item: {
        color: '#000',
        backgroundColor: 'transparent',
        width: '100%',
        alignItems: 'center',
        textAlign: 'center',
        fontFamily: 'serca-condensed-text',
        fontSize: 16,
    },
});

export default useStyles;